import { Directive, Input, OnInit } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[widgetSnippet]'
})
export class WidgetSnippetDirective implements OnInit {
  @Input() widgetKey: string;
  @Input() widgetScriptSrc: string;

  ngOnInit() {
    const html = `  <script type="text/javascript">
    (function(w, f, s, b, k, a) {
      w.cieWidget = { widgetId: k };
      a = f.createElement(s);
      a.async = true;
      a.src = b;
      f.head.appendChild(a);
    })(window, document, 'script',
      '${this.widgetScriptSrc}', '${this.widgetKey}');
  </script>`;

    const fragment = document.createRange().createContextualFragment(html);
    window.document.head.insertBefore(fragment, window.document.head.firstChild);
  }
}
